module.exports = "/*\n\n*/\n:host {\n  position: relative;\n  display: block;\n}\n:host .input-counter {\n  position: absolute;\n  right: 10px;\n  top: 8px;\n  color: #98a6ad;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/input-with-counter/input-with-counter.component.less
// module id = 1178
// module chunks = 0